import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import { ElMessage } from "element-plus";
import { Clock, Bell, User, Timer } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { TimeApi } from "@/api/userApi.js";
export default {
  name: "box-com",
  props: ["list", "type"],
  setup() {
    let router = useRouter();
    let route = useRoute();
    let store = useStore();
    let skillText = {
      S0: "vspt",
      S1: "listen",
      S2: "reading",
      S3: "grammar",
      S4: "writing",
      S5: "oral",
      S9: "mock"
    };
    let time = new Date();
    //更新后台时间
    TimeApi().then(r => {
      time = r.data;
    });
    function endTimeDistance(t) {
      if (t) {
        return t - time <= 7 * 24 * 60 * 60000;
      } else return "";
    }
    function timestamp2Date(timestamp) {
      if (timestamp) {
        let date = new Date(parseInt(timestamp));
        let year = date.getFullYear();
        let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        return year + "-" + month + "-" + d + " " + hour + ":" + minute;
      } else {
        return "";
      }
    }
    function goReport(report, key) {
      if (report.examId == "trial") {
        let url = "";
        switch (key) {
          case "S0":
            {
              url = "/gz/reports/user-report-vspt.html?examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S1":
            {
              url = "/gz/reports/user-report-listen.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S2":
            {
              url = "/gz/reports/user-report-reading.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S3":
            {
              url = "/gz/reports/user-report-grammar.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S4":
            {
              url = "/gz/reports/user-report-writing.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S5":
            {
              url = "/gz/reports/user-report-oral.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
        }
        if (url) window.open(url);
      } else {
        let url = "";
        switch (key) {
          case "S0":
            {
              url = "/gz/reports/user-report-vspt.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S1":
            {
              url = "/gz/reports/user-report-listen.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S2":
            {
              url = "/gz/reports/user-report-reading.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S3":
            {
              url = "/gz/reports/user-report-grammar.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S4":
            {
              url = "/gz/reports/user-report-writing.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
          case "S5":
            {
              url = "/gz/reports/user-report-oral.html?skill=" + key + "&examId=" + report.id + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
              break;
            }
        }
        let info = JSON.parse(window.localStorage.getItem("gz-userInfo"));
        if (info.identity == "试测校") {
          ElMessage({
            type: "warning",
            showClose: true,
            message: "无权限查看报告"
          });
          return;
        }
        if (url) window.open(url);
      }
    }
    function getDurationM(userExam) {
      if (userExam.skill == "S4") {
        let remainingTime = userExam.nextExam ? userExam.nextExam.totalTime - userExam.nextExam.remainingTime : 0;
        return Math.round((userExam.totalTime - userExam.remainingTime + remainingTime) / 60);
      }
      let remainingTime = userExam.nextExam ? userExam.nextExam.remainingTime : userExam.remainingTime;
      return userExam.remainingTime < 0 ? Math.round(userExam.totalTime / 60) : Math.round((userExam.totalTime - remainingTime) / 60);
    }
    function goExam(msg) {
      if (msg.examId == "trial") {
        router.push({
          path: "/trial/exam/" + skillText[msg.skill],
          query: {
            skill: msg.skill
          }
        });
      } else {
        // if (msg.skill == "S0") {
        //   window.location.href =
        //     "/gz/reports/user-vspt-new.html?examId=" +
        //     msg.id +
        //     "&userId=" +
        //     msg.userId;
        // } else {
        window.localStorage.setItem("exam-note", msg.note);
        if (msg.note && msg.note.includes("句子复述（试测）")) {
          router.push({
            path: "/exam/oralq",
            query: {
              examid: msg.id
            }
          });
          return 0;
        }
        router.push({
          path: "/exam/" + skillText[msg.skill],
          query: {
            examid: msg.id
          }
        });
        // }
      }
    }
    return {
      time,
      goReport,
      goExam,
      Timer,
      store,
      Clock,
      Bell,
      User,
      endTimeDistance,
      timestamp2Date,
      getDurationM
    };
  }
};